import { gql } from '@apollo/client'

export default gql(`
    mutation ($id: ID! $mediaId: String!) {
        triggerVwmVideoValidator(
            input: {
                id: $id
                mediaId: $mediaId
            }
        ){
            error
            streamStatus
            status
               
        }
   }`
)
